import { ConversationHistoryResponse, LoadConversationRequest } from '../types/conversationHistory'

export class ConversationHistoryApiService {
  private baseUrl: string

  constructor(baseUrl: string) {
    // Extract the base server URL, removing any API paths
    this.baseUrl = baseUrl.replace(/\/api.*$/, '')
    console.log('🔧 ConversationHistoryApiService baseUrl cleaned:', this.baseUrl)
  }

  async loadConversationHistory(request: LoadConversationRequest): Promise<ConversationHistoryResponse> {
    const { whatsappPhone, limit = 100, offset = 0 } = request
    
    // Build the direct API URL
    const apiUrl = `${this.baseUrl}/api/conversation/history/${encodeURIComponent(whatsappPhone)}`
    const url = new URL(apiUrl)
    url.searchParams.append('limit', limit.toString())
    url.searchParams.append('offset', offset.toString())

    console.log('🔗 Making request to:', url.toString())
    console.log('📞 Phone:', whatsappPhone)
    console.log('🌐 Cleaned Base URL:', this.baseUrl)

    const response = await fetch(url.toString())
    
    console.log('📡 Response status:', response.status)
    
    if (!response.ok) {
      const errorText = await response.text()
      console.error('❌ Response error text:', errorText)
      throw new Error(`Failed to load conversation history: ${response.status} ${response.statusText}`)
    }

    const data = await response.json()
    console.log('✅ Response data:', data)
    
    return {
      ...data,
      messages: data.messages.map((msg: any) => ({
        ...msg,
        timestamp: new Date(msg.timestamp)
      })),
      conversationStartDate: data.conversationStartDate ? new Date(data.conversationStartDate) : undefined
    }
  }
}
